import { __decorate, __metadata } from "tslib";
import { ArrayNotEmpty, ArrayUnique, IsEnum, IsNumber, IsOptional, IsString, IsUUID, Length, Max, Min, } from 'class-validator';
import { SEARCH_MAX_LENGTH, SEARCH_MIN_LENGTH } from './SingleEntitySearchRequest';
/**
 * Search types available in our search API.
 */
export var SearchEntityType;
(function (SearchEntityType) {
    SearchEntityType["Orders"] = "Orders";
    SearchEntityType["Recordings"] = "Recordings";
    SearchEntityType["Cases"] = "Cases";
    SearchEntityType["Hearings"] = "Hearings";
})(SearchEntityType || (SearchEntityType = {}));
/**
 * Requests a search with the provided <code>courtSystemId</code> and <code>searchTerms</code>
 */
export class SearchManyRequest {
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], SearchManyRequest.prototype, "courtSystemId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", Object)
], SearchManyRequest.prototype, "timeZoneId", void 0);
__decorate([
    Length(SEARCH_MIN_LENGTH, SEARCH_MAX_LENGTH),
    __metadata("design:type", String)
], SearchManyRequest.prototype, "searchTerms", void 0);
__decorate([
    IsEnum(SearchEntityType, { each: true }),
    ArrayNotEmpty(),
    ArrayUnique(),
    __metadata("design:type", Array)
], SearchManyRequest.prototype, "entities", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], SearchManyRequest.prototype, "pageToken", void 0);
__decorate([
    IsNumber(),
    Min(1),
    Max(100),
    __metadata("design:type", Number)
], SearchManyRequest.prototype, "limit", void 0);
